module.exports = __webpack_public_path__ + "zimidy-logo.c7d33f1.png";